<!-- eslint-disable max-len -->
<template>
  <div class="d-flex flex-column">
    <!-- Screen Mode & Save -->
    <div
      :class="{ 'screen-mode-and-save-scroll': isScroll }"
      class="screen-mode-and-save justify-content-end"
    >
      <div class="wrap-screen-mode justify-content-end">
        <button
          class="save-button"
          @click="submitForm">
          Save
        </button>
      </div>
    </div>

    <!-- Card Page -->
    <div class="card-page">
      <!-- Button Code Editor per View -->
      <div class="icon-code-editor">
        <img
          src="@/assets/new-form-ui/code-editor.svg"
          @click="openModalCodeEditor"
        >
        <div class="tooltip-component">
          Code Editor
        </div>
      </div>
      <!-- Button Properties setup view -->
      <div
        :class="{'error-input' : $v.dataSetup.sorting.key.$error || $v.dataSetup.sorting.order.$error}"
        class="icon-setup-view"
        @click="openTableConfiguration"
      >
        <img
          src="@/assets/new-form-ui/setup.svg"
        >
        <div class="tooltip-component">
          Configuration
        </div>
      </div>

      <!-- Title -->
      <div class="card-page-title card-page-title-white">
        <b-form>
          <input
            v-model="dataSetup.title"
            :class="{'error-input' : $v.dataSetup.title.$error}"
            type="text"
            class="input-title"
            placeholder="Enter title here"
          >
        </b-form>
      </div>

      <div class="card-page-content pt-3">
        <!-- Summary Block -->
        <section>
          <j-skeleton-summary-block v-if="isLoading"/>

          <div
            v-if="!isLoading"
            class="wrap-summary-block"
          >
            <!-- Default Block -->
            <div
              v-for="(data, index) in dataSetup.summary_block"
              v-show="(index + 1) < lengthDefaultSummaryBlockApprover"
              :key="data.key"
            >
              <j-summary-workflow
                :type="'approver'"
                :master-data="dataSetup.summary_block"
                :data="data"
                :index="index"
                @open-modal="openConfigBlock"
              />
            </div>

            <!-- Custom Block -->
            <draggable
              v-model="dataSetup.summary_block"
              :options="{
                animation:300,
              }"
              style="display: flex;"
            >
              <div
                v-for="(data, index) in dataSetup.summary_block"
                v-show="(index + 1) > (lengthDefaultSummaryBlockApprover - 1) && (index + 1) !== dataSetup.summary_block.length"
                :key="data.key"
              >
                <j-summary-workflow
                  :type="'approver'"
                  :master-data="dataSetup.summary_block"
                  :data="data"
                  :index="index"
                  :extend-class="'sum-custom'"
                  @open-modal="openConfigBlock"
                  @delete-block="deleteBlockWithoutConfirm"
                />
              </div>
            </draggable>

            <!-- Add Block -->
            <div
              class="add-block"
              @click="openConfigBlock(null, null)"
            >
              <img
                :src="require('@/assets/icon/add.png')"
                class="m__r--5"
                height="15"
                width="15">
              Add Block
            </div>

            <!-- Rejected -->
            <div>
              <j-summary-workflow
                :master-data="dataSetup.summary_block"
                :data="dataSetup.summary_block[dataSetup.summary_block.length - 1]"
                :index="dataSetup.summary_block.length - 1"
                @open-modal="openConfigBlock"
              />
            </div>
          </div>
        </section>

        <!-- Filter Search Option -->
        <section v-if="dataSetup.auto_show_search_options_list">
          <popup-filter
            :filters="dataSetup.search_options_list"
            :is-auto-show="true"
          />
        </section>

        <!-- Column -->
        <section class="mt-4">
          <!-- Button -->
          <div class="d-flex align-items-center mb-2">
            <!-- Filter Button -->
            <div
              v-if="!dataSetup.auto_show_search_options_list"
              class="wrap-button-table"
            >
              <b-button
                id="filterPopover"
                class="btn grey btn-import-form m__r--5"
                @click="showPopover = true"
              >
                <i class="fa fa-filter fa-lg"/> {{ dataSetup.config_native_button_table.filter.label || 'Filter' }}
              </b-button>

              <div class="edit-or-delete">
                <div class="button">
                  <div
                    class="edit"
                    @click.stop="openModalNativeButtonTable(true, 'filter')">
                    <i class="fa fa-pencil-square-o" />
                  </div>
                  <div class="delete">
                    <i
                      v-if="!dataSetup.config_native_button_table.filter.is_hidden"
                      class="fa fa-eye"/>
                    <img
                      v-else
                      style="width: 12px;"
                      src="@/assets/icon/eye-close.svg">
                  </div>
                </div>
              </div>
            </div>

            <!-- Group Button -->
            <div class="wrap-button-table">
              <b-button class="button-table">
                <i class="fa fa-table fa-lg"/> {{ dataSetup.config_native_button_table.group.label || 'Group' }}
              </b-button>

              <div class="edit-or-delete">
                <div class="button">
                  <div
                    class="edit"
                    @click.stop="openModalNativeButtonTable(true, 'group')">
                    <i class="fa fa-pencil-square-o" />
                  </div>
                  <div class="delete">
                    <i
                      v-if="!dataSetup.config_native_button_table.group.is_hidden"
                      class="fa fa-eye"/>
                    <img
                      v-else
                      style="width: 12px;"
                      src="@/assets/icon/eye-close.svg">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading Table -->
          <j-skeleton-table v-if="isLoading" />

          <!-- If have data setup column -->
          <div
            v-if="!isLoading"
            class="columns"
          >
            <draggable
              v-model="dataSetup.column"
              class="d-flex align-items-center"
            >
              <div
                v-for="(data, index) in dataSetup.column"
                :key="index"
                class="column"
              >
                <div class="header-list">
                  <img :src="require(`@/assets/icon/column-type/${setIconType(data.type)}.svg`)">
                  <div class="separator" />
                  <div class="column-name">
                    {{ data.name }}
                  </div>

                  <!-- Edit or Delete -->
                  <div class="edit-or-delete">
                    <div class="button">
                      <!-- Edit -->
                      <div
                        class="edit"
                        @click="openConfigColumn(data, index)"
                      >
                        <i class="fa fa-pencil-square-o" />
                        <div class="tooltip-component">Edit column</div>
                      </div>
                      <!-- Delete -->
                      <div
                        class="delete"
                        @click="deleteColumn(index)"
                      >
                        <i class="fa fa-trash" />
                        <div class="tooltip-component">Delete column</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="index in 4"
                  :key="index"
                  :class="{'bg-gray': index === 2 || index === 4}"
                  class="column-preview"
                >
                  <div class="content-preview"/>
                </div>
              </div>
            </draggable>

            <!-- Add Block -->
            <div class="column">
              <div class="header-list">
                <div
                  :class="{'in-right' : dataSetup.column.length === 0}"
                  class="btn-add-block"
                  @click="openConfigColumn(null, null)"
                >
                  <i class="fa fa-plus"/>
                </div>
              </div>
              <div
                v-for="index in 4"
                :key="index"
                :class="{'bg-gray': index === 2 || index === 4}"
                class="column-preview"
              >
                <div class="content-preview"/>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- Popover Filter -->
    <b-popover
      v-if="!dataSetup.auto_show_search_options_list"
      :show.sync="showPopover"
      target="filterPopover"
      container="newExperienceManager"
      triggers="click blur"
      placement="bottom"
    >
      <popup-filter
        :filters="dataSetup.search_options_list"
      />
    </b-popover>

    <!-- Configuration -->
    <table-configuration
      v-if="isOpenTableConfiguration"
      id="tableConfiguration"
      :data-config="dataSetup"
      :list-function="listFunction"
      :variables="variableOptions"
      :variable-options="variableOptionsClass"
      :variable-options-column="variableOptionsColumn"
      :is-have-configuration="isHaveConfiguration"
      :source-type="sourceType"
      type="approver"
      @delete-view="deleteView"
      @close-configuration="toggleConfiguration(false)"
      @submit="submitConfig"
    />

    <!-- Configuration Summary Block -->
    <summary-block-configuration
      v-if="isOpenConfigBlock"
      :id="idConfigBlock"
      :field-detail="selectedBlock"
      :variable-options="variableOptionsClass"
      :list-function="listFunction"
      type="approver"
      @delete-configuration="deleteBlockWithoutConfirm"
      @close-configuration="toggleConfigurationBlock(false)"
      @submit-configuration="submitBlock"
    />

    <!-- Configuration Column -->
    <column-configuration
      v-if="isOpenConfigColumn"
      :id="idConfigColumn"
      :field-detail="selectedColumn"
      :select-variable="variableOptionsColumn"
      :action-buttons="dataSetup.action_buttons"
      :type="'table_approver'"
      :variable-options="variableOptions"
      :list-function="listFunction"
      @delete-configuration="deleteColumn"
      @close-configuration="toggleConfigurationColumn(false)"
      @submit-configuration="submitColumn"
    />

    <!-- Modal Field Library -->
    <modal-field-library
      v-if="showModalFieldLibrary"
      @close-modal="closeModalFieldLibrary"
    />

    <!-- Modal External Api -->
    <b-modal
      ref="modalExternalApi"
      :hide-header="true"
      :hide-footer="true"
      class="modal-external-api"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-external-api-field
        v-if="showModalExternalUrl"
      />
    </b-modal>

    <!-- Modal Script Action Button -->
    <b-modal
      ref="modalScriptActionBtn"
      :hide-header="true"
      :hide-footer="true"
      class="modal-native-action-button"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-script-action-btn
        v-if="showModalScriptActionBtn"
      />
    </b-modal>

    <!-- Modal Native Button Table -->
    <modal-native-button-table
      v-if="showModalNativeButton"
      :id="idModalNativeButtonTable"
      :data="dataSetup.config_native_button_table[selectedNativeButton]"
      @close-modal="closeModalNativeButtonTable"
      @submit="submitNativeButtonTable"
    />

    <!-- Modal Code Editor -->
    <b-modal
      ref="modalCodeEditor"
      :hide-header="true"
      :hide-footer="true"
      class="modal-code-editor-wrap"
      no-close-on-backdrop
      no-close-on-esc
    >
      <modal-code-editor
        v-if="showModalCodeEditor"
        :view-data="viewJsonData"
        view-title="Table Approver View"
        type="table_approver_view"
        @close="closeModalCodeEditor"
        @update="updateViewByCode"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, camelcase, no-console */
import { required } from 'vuelidate/lib/validators';
import jwtDecode from 'jwt-decode';
import draggable from 'vuedraggable';
// Mixins
import jMixTableView from '@/mixins/form-ui-v2/jMixTableView';
import jMixToolbox from '@/mixins/form-ui-v2/jMixToolbox';
import jMixSetupSummaryBlock from '@/mixins/form-ui-v2/jMixSetupSummaryBlock';
import jMixSetupColumn from '@/mixins/form-ui-v2/jMixSetupColumn';
import jMixScroll from '@/mixins/form-ui-v2/jMixScroll';
import jMixCodeEditorPerView from '@/mixins/form-ui-v2/jMixCodeEditorPerView';
// Component
import jTooltipCreateView from '@/components/tooltip/jTooltipCreateView';
import PopupFilter from '@/views/experience-manager-v2/popup/PopupFilter';
import jSummaryWorkflow from '@/components/summary/jSummaryWorkflow';
import TableConfiguration from '@/views/experience-manager-v2/partials/configuration/TableConfiguration';
import SummaryBlockConfiguration from '@/views/experience-manager-v2/partials/configuration/SummaryBlockConfiguration';
import ColumnConfiguration from '@/views/experience-manager-v2/partials/configuration/ColumnConfiguration';
import ModalFieldLibrary from '@/views/experience-manager-v2/popup/ModalFieldLibrary';
import ModalExternalApiField from '@/views/experience-manager-v2/popup/ModalExternalApiField';
import jSkeletonTable from '@/views/experience-manager-v2/loading/jSkeletonTable';
import jSkeletonSummaryBlock from '@/views/experience-manager-v2/loading/jSkeletonSummaryBlock';
import ModalScriptActionBtn from '@/views/experience-manager-v2/popup/ModalScriptActionBtn';
import ModalNativeButtonTable from '@/views/experience-manager-v2/popup/ModalNativeButtonTable';
import ModalCodeEditor from '@/views/experience-manager-v2/popup/ModalCodeEditor';

export default {
  components: {
    draggable,
    PopupFilter,
    jTooltipCreateView,
    jSummaryWorkflow,
    TableConfiguration,
    SummaryBlockConfiguration,
    ColumnConfiguration,
    ModalFieldLibrary,
    ModalExternalApiField,
    jSkeletonTable,
    jSkeletonSummaryBlock,
    ModalScriptActionBtn,
    ModalNativeButtonTable,
    ModalCodeEditor,
  },

  mixins: [jMixSetupColumn, jMixTableView, jMixToolbox, jMixSetupSummaryBlock, jMixScroll, jMixCodeEditorPerView],

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: true,
      dataSetup: {
        title: null,
        server_side_pagination: false,
        column: [],
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
            skip_null_value: false,
          },
        ],
        filterOperator: null,
        isHideCheckbox: false,
        auto_show_search_options_list: false,
        search_options_list: [],
        summary_block: [],
        action_buttons: [],
        config_native_button_table: {
          add: {
            label: 'Add',
            is_hidden: false,
          },
          import: {
            label: 'Import',
            is_hidden: false,
          },
          export: {
            label: 'Export',
            is_hidden: false,
          },
          filter: {
            label: 'Filter',
            is_hidden: false,
          },
          group: {
            label: 'Group',
            is_hidden: false,
          },
        },
        config_preview_data: {
          is_show_summary_data: false,
          summary_data: '',
          summary_label: '',
          is_show_summary_list: false,
          summary_list_type: null,
          summary_list: [],
        },
        row_expansion: false,
        rows_page_default: 10,
        rows_page_option: [10, 20, 50, 100],
        freeze_header_table: false,
        config_tag_filter: null,
        disable_redirect_detail_page: false,
      },
      variableOptions: [],
      variableOptionsClass: [],
      variableOptionsColumn: [],
      listFunction: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      isError: false,
      problemMessage: '',
      isOpenTableConfiguration: false,
    };
  },

  computed: {
    genData() {
      const { title, server_side_pagination, column, sorting, filter, filter_function, filterOperator,
        isHideCheckbox, auto_show_search_options_list, search_options_list, summary_block,
        action_buttons, config_native_button_table, config_preview_data, row_expansion,
        rows_page_default, rows_page_option, freeze_header_table, config_tag_filter,
        disable_redirect_detail_page } = this.dataSetup;

      const params = this._.cloneDeep(this.formDetail);
      params.table_approver_view = {
        title,
        server_side_pagination,
        action_buttons: null,
        columns: column,
        sort: [],
        filter: {},
        filter_function: {},
        filter_operator: filterOperator,
        is_hide_checkbox: isHideCheckbox,
        auto_show_search_options_list,
        search_options_list: search_options_list.length > 0 ? search_options_list : null,
        summary_block: summary_block.length > 0 ? summary_block : null,
        config_native_button_table,
        config_preview_data,
        row_expansion,
        rows_page_default,
        rows_page_option,
        freeze_header_table,
        filter_function_skip_null: {},
        config_tag_filter,
        disable_redirect_detail_page,
      };

      params.table_approver_view.sort.push({
        [sorting.key.id]: sorting.order.id === 'asc' ? 1 : -1,
      });
      if (filter.length > 0) {
        filter.forEach((e) => {
          if (e.key) {
            params.table_approver_view.filter[e.key.id] = e.value;
          }
        });
      }
      if (filter_function.length > 0) {
        filter_function.forEach((e) => {
          if (e.key) {
            params.table_approver_view.filter_function[e.key.id] = e.value;
            params.table_approver_view.filter_function_skip_null[e.key.id] = e.skip_null_value || false;
          }
        });
      }
      if (action_buttons && action_buttons.length > 0) {
        const dataActionbuttons = [];
        column.forEach((c) => {
          if (c.config && c.config.action_buttons) {
            c.config.action_buttons.forEach((a) => {
              const findAction = action_buttons.find(f => f.key === a);
              if (findAction) {
                dataActionbuttons.push(findAction);
              }
            });
          }
        });
        params.table_approver_view.action_buttons = dataActionbuttons.length > 0 ? dataActionbuttons : null;
      }
      return params;
    },

    isHaveConfiguration() {
      return !!this.formDetail.table_approver_view;
    },

    sourceType() {
      return this.formDetail && this.formDetail.type;
    },

    viewJsonData() {
      return JSON.stringify(this.formDetail.table_approver_view, null, 4);
    },
  },

  async created() {
    if (this.formDetail.form_data_id) {
      const dataFilter = {
        id: [this.formDetail.form_data_id],
      };
      const param = {
        limit: 0,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      await this.actionGetDetailFormData(param);
      this.isLoading = false;
    } else {
      this.isLoading = false;
    }
    this.getListFunction();
  },

  methods: {
    setDetail(columns) {
      const listColumns = Object.keys(columns);
      const listColumnsVal = Object.values(columns);

      this.variableOptions = [];
      this.variableOptionsClass = [];
      this.variableOptionsColumn = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column, index) => {
          if (listColumnsVal[index].type !== '[]attachment') {
            this.variableOptions.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
            this.variableOptionsColumn.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });

            if (listColumnsVal[index].type === 'person') {
              this.variableOptionsClass.push({
                id: `${column}.company_user_id`,
                label: `${column}.company_user_id`,
                text: `${column}.company_user_id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.email`,
                label: `${column}.email`,
                text: `${column}.email`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'object') {
              this.variableOptionsClass.push({
                id: `${column}.id`,
                label: `${column}.id`,
                text: `${column}.id`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'timer') {
              this.variableOptionsClass.push({
                id: `${column}.state`,
                label: `${column}.state`,
                text: `${column}.state`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.duration`,
                label: `${column}.duration`,
                text: `${column}.duration`,
                type: listColumnsVal[index].type,
              });
            } else if (listColumnsVal[index].type === 'tags') {
              this.variableOptionsClass.push({
                id: `${column}.name`,
                label: `${column}.name`,
                text: `${column}.name`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.background`,
                label: `${column}.background`,
                text: `${column}.background`,
                type: listColumnsVal[index].type,
              });
              this.variableOptionsClass.push({
                id: `${column}.font_color`,
                label: `${column}.font_color`,
                text: `${column}.font_color`,
                type: listColumnsVal[index].type,
              });
            } else {
              this.variableOptionsClass.push({
                id: column,
                label: column,
                text: column,
                type: listColumnsVal[index].type,
              });
            }
          } else {
            this.variableOptionsColumn.push({
              id: column,
              label: column,
              text: column,
              type: listColumnsVal[index].type,
            });
          }
        });
      }

      if (this.formDetail.table_approver_view) {
        const data = JSON.parse(JSON.stringify(this.formDetail.table_approver_view));
        const { title, server_side_pagination, filter_operator, is_hide_checkbox, auto_show_search_options_list,
          search_options_list, summary_block, action_buttons, config_native_button_table, config_preview_data,
          row_expansion, rows_page_default, rows_page_option, freeze_header_table, filter_function_skip_null,
          config_tag_filter, disable_redirect_detail_page } = data;

        this.dataSetup.title = title;
        this.dataSetup.server_side_pagination = server_side_pagination || false;
        this.dataSetup.filterOperator = filter_operator || null;
        this.dataSetup.isHideCheckbox = is_hide_checkbox || false;
        this.dataSetup.auto_show_search_options_list = auto_show_search_options_list || false;
        this.dataSetup.search_options_list = search_options_list || [];
        this.dataSetup.summary_block = summary_block || [];
        this.dataSetup.action_buttons = action_buttons || [];
        this.dataSetup.config_native_button_table = config_native_button_table;
        this.dataSetup.config_preview_data = config_preview_data;
        this.dataSetup.row_expansion = row_expansion;
        this.dataSetup.rows_page_default = rows_page_default;
        this.dataSetup.rows_page_option = rows_page_option || [10, 20, 50, 100];
        this.dataSetup.freeze_header_table = freeze_header_table;
        this.dataSetup.config_tag_filter = config_tag_filter;
        this.dataSetup.disable_redirect_detail_page = disable_redirect_detail_page;

        if (this.formDetail.table_approver_view.columns && this.formDetail.table_approver_view.columns.length > 0) {
          this.dataSetup.column = [];
          this.formDetail.table_approver_view.columns.forEach((column) => {
            this.dataSetup.column.push({
              name: column.name,
              key: column.key,
              type: column.type ? column.type : 'text',
              sort: column.sort,
              content_alignment: column.content_alignment ? column.content_alignment : 'left',
              config: column.config || null,
            });
          });
        }

        const { sort, filter, filter_function } = this.formDetail.table_approver_view;
        if (sort) {
          const keySort = Object.keys(sort[0]);
          const valueSort = Object.values(sort[0]);

          this.dataSetup.sorting = {
            key: { id: keySort[0] },
            order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
          };
        }

        if (filter) {
          const keyFilter = Object.keys(filter);
          const valueFilter = Object.values(filter);
          if (keyFilter.length > 0) {
            this.dataSetup.filter = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter.push({
                key: { id: e },
                value: valueFilter[index],
              });
            });
          }
        }

        if (filter_function) {
          const keyFilter = Object.keys(filter_function);
          const valueFilter = Object.values(filter_function);
          if (keyFilter.length > 0) {
            this.dataSetup.filter_function = [];
            keyFilter.forEach((e, index) => {
              this.dataSetup.filter_function.push({
                key: { id: e },
                value: valueFilter[index],
                skip_null_value: filter_function_skip_null ? (filter_function_skip_null[e] || false) : false,
              });
            });
          }
        }
      } else {
        this.dataSetup.summary_block = this.defaultSummaryBlockApprover;
      }
    },

    resetData() {
      this.dataSetup = {
        title: null,
        server_side_pagination: false,
        column: [],
        sorting: {
          key: null,
          order: null,
        },
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filter_function: [
          {
            key: null,
            value: null,
            skip_null_value: false,
          },
        ],
        filterOperator: null,
        isHideCheckbox: false,
        auto_show_search_options_list: false,
        search_options_list: [],
        summary_block: [],
        config_native_button_table: {
          add: {
            label: 'Add',
            is_hidden: false,
          },
          import: {
            label: 'Import',
            is_hidden: false,
          },
          export: {
            label: 'Export',
            is_hidden: false,
          },
          filter: {
            label: 'Filter',
            is_hidden: false,
          },
          group: {
            label: 'Group',
            is_hidden: false,
          },
        },
        row_expansion: false,
        rows_page_default: 10,
        rows_page_option: [10, 20, 50, 100],
        freeze_header_table: false,
        config_tag_filter: null,
        disable_redirect_detail_page: false,
      };
    },
  },

  validations() {
    return {
      dataSetup: {
        title: { required },
        description: {},
        server_side_pagination: {},
        column: {
          // $each: {
          //  name: { required },
          //  key: { required },
          //  type: { required },
          // },
        },
        sorting: {
          key: {
            required,
          },
          order: {
            required,
          },
        },
        filter: {},
        filter_function: {},
        filterOperator: {},
        isHideCheckbox: {},
        search_options_list: {},
        summary_block: [],
        config_native_button_table: {},
        row_expansion: {},
        rows_page_default: {},
        rows_page_option: {},
        freeze_header_table: {},
        config_tag_filter: {},
        disable_redirect_detail_page: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/menu/jTableAppView.vue